<template>
  <span v-show="isShowPage">
    <!-- <v-row>
      <v-col class="text-right">
         <span v-if="items.length > 0">{{ items.length + 1 + ' data ditemukan' }}</span>
        <v-btn class="ma-2" depressed outlined :color="colorActive" @click="openDialogFilter()">
          <v-icon left :color="colorActive"> $ic-filter </v-icon>
          Filter
        </v-btn>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col>
        <!-- <v-alert border="bottom" colored-border color="#C53830" elevation="2"> -->
        <v-row class="xcards ml-2 mr-2">
          <v-col cols="12">
            <span class="summary-alert-title" v-html="'Jumlah Transaksi'"></span>
          </v-col>
          <v-col cols="12">
            <span class="summary-alert-value">{{ cardItems.merah }}</span>
          </v-col>
        </v-row>
        </v-alert>
      </v-col>
      <v-col>
        <!-- <v-alert border="bottom" colored-border color="#FFD600" elevation="2"> -->
        <v-row class="xcards  ml-2 mr-2">
          <v-col cols="12">
            <span class="summary-alert-title">Akumulasi kWh</span>
          </v-col>
          <v-col cols="12">
            <span class="summary-alert-value">{{ formatCurrency(cardItems.hijau) }} kWh</span>
          </v-col>
        </v-row>
        </v-alert>
      </v-col>
      <v-col>
        <!-- <v-alert border="bottom" colored-border color="#397E5D" elevation="2"> -->
        <v-row class="xcards  ml-2 mr-2">
          <v-col cols="12">
            <span class="summary-alert-title">Total Rp</span>
          </v-col>
          <v-col cols="12">
            <span class="summary-alert-value">   {{ indoCurrencyFormat().format(cardItems.kuning) }}</span>
          </v-col>
        </v-row>
        </v-alert>
      </v-col>

    </v-row>

    <hr v-if="showMap" class="line-separator" />
    <span class="page-sub-title">{{ table_title }}</span>
    <v-row align="center" justify="center" class="mt-1">
      <v-col cols="3">
        <v-text-field append-icon="mdi-magnify" outlined solo hide-details v-model="search" class="search"
          placeholder="Search..." color="#2671D9">
        </v-text-field>
      </v-col>

      <!-- <v-col cols="4">
        <v-menu v-model="dateMenu" :nudge-right="40" :close-on-content-click="false" transition="scale-transition"
          offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field append-icon="mdi-chevron-down" prepend-icon="mdi-calendar" label="Tanggal" readonly
              :value="dateDisp" v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="searchDate" :active-picker.sync="activePicker"
            :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)" range
            locale="id-ID">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dateMenu = false; searchDate = []">
              Cancel
            </v-btn>
            <v-btn text color="primary" @click="dateMenu = false">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col> -->
      <v-btn class="ma-2" depressed outlined :color="colorActive" @click="openDialogFilter()">
        <v-icon left :color="colorActive"> $ic-filter </v-icon>
        Filter
      </v-btn>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-btn class="ma-2" depressed outlined color="#2671D9" @click="downloadExcel()">
          <v-icon left color="#2671D9"> $ic-export-excel </v-icon>
          Export Excel
        </v-btn>
        <download-excel id="d" v-show="false" :data="itemsExcel" :name="'Detail Transaksi ' + this.dateExportFormat()"
          :header="'Detail Transaksi ' + this.dateExportFormat()">
        </download-excel>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-5">

        <v-data-table :headers="headers" :items="items" :items-per-page="itemsPerPage" class="datatable" :search="search"
          hide-default-footer :page.sync="page" @page-count="pageCount = $event" item-key="key">
          <template v-slot:item.jml_transaksi="{ item }">
            {{ formatCurrency(item.jml_transaksi).split(",")[0] }}
          </template>
        </v-data-table>
        <v-row>
          <v-col class="mt-5" cols="6">
            Menampilkan
            <v-select v-model="itemsPerPage" :items="[5, 10, 20, 30, 50]" dense solo flat class="ml-1 mr-1 size-select"
              @change="
                itemsPerPage = parseInt($event, 10);
              page = 1;
              "></v-select>
            data dari <b>{{ items.length }}</b>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="text-right mt-5" cols="6">
            <v-pagination v-model="page" :length="pageCount" :total-visible="5"></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>
              <span>{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" class="text-right">
              <v-btn icon x-small @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="pb-0 pt-1">
                <v-list>
                  <template v-for="(item, index) in chargeBoxList">
                    <v-list-item :key="index">
                      <v-icon v-if="item.isActive" class="mr-5">$ic-spklu-blue</v-icon>
                      <v-icon v-else class="mr-5">$ic-spklu-red</v-icon>
                      <v-list-item-content>
                        <v-list-item-title v-html="item.namaChargebox"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.dayaChargebox"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                          </template>
                          <span v-for="(connector, j) in item.connectors" :key="connector.j">
                            <table>
                              <tr>
                                <td>{{ "(" + parseInt(j + 1) + ")" }}</td>
                                <td>Nama Connector</td>
                                <td>: {{ connector.namaKonektor }}</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>Status Connector</td>
                                <td>
                                  :
                                  <span>{{
                                    enumToStatus(connector.status)
                                  }}</span>
                                </td>
                              </tr>
                            </table>
                          </span>
                        </v-tooltip>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small depressed :color="colorActive" dark @click="dialog = false">
            Kembali
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogFilter" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>
              <span>Filter Data</span>
            </v-col>
            <v-col class="text-right">
              <v-btn icon x-small @click="dialogFilter = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
<!--            <v-row>-->
<!--              <v-col class="pb-0 pt-1">-->
<!--                <div class="label-custom mb-2" :style="'color:' + colorActive">-->
<!--                  Jumlah Transaksi-->
<!--                </div>-->
<!--                <v-autocomplete v-model="input.jml_transaksi" :items="optionsJmlTransaksi" label="Semua Jumlah Transaksi"-->
<!--                  dense solo flat outlined item-text="name" item-value="id" return-object cache-items clearable-->
<!--                  :color="colorActive">-->
<!--                </v-autocomplete>-->
<!--              </v-col>-->
<!--            </v-row>-->
            <v-row>
              <v-col class="pb-0 pt-1">
                <v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field style="padding: 0 !important;" append-icon="mdi-chevron-down"
                      prepend-icon="mdi-calendar" label="Tanggal" readonly :value="dateDisp" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="searchDate" no-title range :allowed-dates="allowedDates" locale="id-ID"
                    :min="searchDate[0] ? searchDate[0] : ''"></v-date-picker>
                  <v-btn block @click="dateMenu = false">
                    OK
                  </v-btn>
                  <v-btn block @click="dateMenu = false; searchDate = []">
                    Clear
                  </v-btn>
                </v-menu>
              </v-col>
<!--              <v-col class="pb-0 pt-1">-->
<!--                <div class="label-custom mb-2" :style="'color:' + colorActive">-->
<!--                  Status-->
<!--                </div>-->
<!--                <v-autocomplete v-model="input.is_active" :items="optionsAvailability" label="Semua Status" dense solo-->
<!--                  flat outlined item-text="name" item-value="id" return-object cache-items clearable :color="colorActive">-->
<!--                </v-autocomplete>-->
<!--              </v-col>-->
            </v-row>
            <v-row>
              <v-col class="pb-5 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Unit
                </div>
                <v-text-field v-model="input.searchBranch"  label="Cari Lokasi" dense solo flat outlined clearable>
                </v-text-field>
                <span>Selected:
                  {{
                    input.branch.name ? input.branch.name : "unit belum dipilih"
                  }}
                  <v-icon v-show="input.branch.id" @click="input.branch = {}; active = [];">mdi-close</v-icon>
                </span>
                <div v-show="!input.branch.id" style="overflow-y: scroll; height: 300px">
                  <v-treeview activatable :active="active" :items="tempOptionsBranch"
                    @update:active="treeClick"></v-treeview>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Nama SPKLU
                </div>
                <v-autocomplete v-model="input.spklu" :items="optionsSpklu" label="Semua SPKLU" dense solo flat outlined
                  item-text="name" item-value="id" return-object  :color="colorActive"
                  :search-input.sync="searchSpkluKeyword" :loading="awaitingSearch" clearable>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small depressed color="#999999" text @click="dialogFilter = false">
            Kembali
          </v-btn>
          <v-btn small depressed :color="colorActive" @click="
            dialogFilter = false;
          reGetData();
          " dark>
            Cari
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import 'leaflet/dist/leaflet.css'
import { latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from 'vue2-leaflet'
import SpkluService from '@/services/default/SpkluService'
import RefService from '@/services/default/RefService'
import { StorageService } from '@/services/storage.service'

const spkluService = SpkluService.build()
const refService = RefService.build()
export default {
  name: 'spklu-lokasi-spklu',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon
  },
  data: () => ({
    dateMenu: false,
    searchDate: [],
    search: '',
    dateTimeString: '',
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',
    cardItems: {
      hijau: 0,
      kuning: 0,
      merah: 0,
      biru: 0
    },
    headers: [
      // { value: 'number', text: 'No.', sortable: false, align: 'center' },
      { value: 'periode', text: 'PERIODE', align: 'right' },
      { value: 'tanggal', text: 'TANGGAL', align: 'right' },
      { value: 'trxid', text: 'TRXID', align: 'right' },
      { value: 'namaupi', text: 'UIW/UID', align: 'left' },
      { value: 'namaap', text: 'UP3', align: 'left' },
      { value: 'namaup', text: 'ULP', align: 'left' },

      { value: 'provinsi', text: 'PROV', align: 'left' },
      { value: 'pemda', text: 'KOTA/KAB', align: 'left' },
      { value: 'idSpklu', text: 'ID_SPKLU', align: 'right' },
      { value: 'namaSpklu', text: 'NAMA_SPKLU', align: 'left' },
      { value: 'namaChargebox', text: 'NAMA_CHARGEBOX', align: 'left' },

      { value: 'chargeboxId', text: 'CHARGEBOX_ID', align: 'left' },
      { value: 'dayaChargebox', text: 'DAYA_CHARGEBOX', align: 'right' },
      { value: 'namaConnector', text: 'NAMA_CONNECTOR', align: 'left' },
      { value: 'connectorId', text: 'CONNECTOR_ID', align: 'right' },
      { value: 'kwh', text: 'KWH', align: 'right' },
      { value: 'rpkwh', text: 'RPKWH', align: 'right' },

      { value: 'rpppj', text: 'RPPPJ', align: 'right' },
      { value: 'rpmat', text: 'RPMAT', align: 'right' },
      { value: 'rpadmin', text: 'RPADMIN', align: 'right' },
      { value: 'rppakai', text: 'RPPAKAI', align: 'right' },
      { value: 'payment', text: 'PAYMENT', align: 'right' },

      // { value: 'periode', text: 'TGL_START', align: 'right' },
      // { value: 'periode', text: 'TGL_STOP', align: 'right' },
      { value: 'durasi', text: 'DURASI', align: 'right' }

    ],
    items: [],
    sortSettings: '',
    isFetching: false, // for datatable
    locationMarkerList: [],

    // map properties
    zoom: 5,
    center: latLng(-2.372369, 115.421875),
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    showParagraph: false,
    mapOptions: {
      // zoomSnap: 0.5
      zoomControl: true,
      touchZoom: false,
      doubleClickZoom: false,
      scrollWheelZoom: true,
      boxZoom: false,
      keyboard: false,
      dragging: true
    },
    showMap: false,
    isShowPage: false,
    mapObj: {},
    table_title: '',
    timer: '',
    // dialog properties
    dialog: false,
    dialogTitle: '',
    chargeBoxList: [],
    showTooltip: false,
    // client side pagination properties
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    // filter
    input: {
      jml_transaksi: {},
      branch: {},
      spklu: {},
      searchBranch: '',
      is_active: {}
    },
    dialogFilter: false,
    optionsJmlTransaksi: [
      { id: 'hijau', name: 'Jumlah Transaksi' },
      { id: 'kuning', name: 'Akumulasi kWh' },
      { id: 'merah', name: 'Total Rp' }
      // { id: "biru", name: "SPKLU Non PLN" },
    ],
    optionsAvailability: [
      { id: 'active', name: 'Available' },
      { id: 'inactive', name: 'Unavailable' }
    ],
    optionsSpklu: [],
    optionsLokasi: [],
    optionsBranch: [],
    tempOptionsBranch: [],
    searchSpkluKeyword: '',
    awaitingSearch: false,
    active: [],
    itemsExcel: [],
    param: {},
    tanggalSekarang: ''
  }),
  async created () {
    const currentDate = new Date()

    const year = currentDate.getFullYear()
    const month = String(currentDate.getMonth() + 1).padStart(2, '0')
    const day = String(currentDate.getDate()).padStart(2, '0')

    const endDate = `${year}-${month}-${day}`

    // Get the date for last month
    const lastMonthDate = new Date(currentDate)
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1)

    const lastMonthYear = lastMonthDate.getFullYear()
    const lastMonthMonth = String(lastMonthDate.getMonth() + 1).padStart(2, '0')
    const lastMonthDay = String(lastMonthDate.getDate()).padStart(2, '0')

    const startDate = `${lastMonthYear}-${lastMonthMonth}-${lastMonthDay}`

    this.param = Object.assign({
      startDate: startDate,
      endDate: endDate
    })
    this.table_title = 'Detail Transaksi'
    this.isShowPage = true
    this.showMap = true
    this.getSpkluData(this.param)
    this.getSpkluCard(this.param)
    this.getBranchList()
  },
  computed: {
    dateDisp () {
      return this.searchDate.join(' ~ ')
      // format/do something with date
    }
  },
  mounted: async function () {
    const responseAuth = await StorageService.getAuthdata()
    const newVal = this.input.branch.id
    const oldVal = responseAuth.branch.idBranch

    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
    const day = currentDate.getDate().toString().padStart(2, '0')

    const formatTanggal = `${day}-${month}-${year}`;

    this.tanggalSekarang = formatTanggal;

    const start = `${year}-${month}-01`
    const end = `${year}-${month}-${day}`

    // const formattedRange = `${start} ~ ${end}`


    if (newVal === undefined) {
      this.searchDate.push(start, end)
      this.param.startDate = this.searchDate[0]
      this.param.endDate = this.searchDate[1]

      if (responseAuth.branch.name !== 'PUSAT') {
        this.input.branch.id = responseAuth.branch.idBranch
        this.input.branch.name = responseAuth.branch.name
      }
      await this.getOptionsSpklu(oldVal)
      await this.reGetData()
    }

    // if (this.$route.path === '/dashboard/spklu-fast-charging') {
    //   this.$nextTick(() => {
    //     this.map = this.$refs.map.mapObject
    //     this.mapObj = this.map
    //   })
    //   // re-get data every 1 minute
    //   this.timer = setInterval(() => {
    //     this.resetData()
    //     // this.getSpkluACHomeCharging()
    //     const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
    //     if (tableQuery) {
    //       this.getDataTable(tableQuery.page, tableQuery.size)
    //     } else {
    //       this.getDataTable()
    //     }
    //     this.isShowPage = true
    //   }, 60000)
    // }
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    'input.branch': function (newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        this.getOptionsSpklu(newVal.id)
      }
    },
    'input.searchBranch': function (val) {
      if (!val) {
        this.tempOptionsBranch = this.optionsBranch
      } else {
        this.tempOptionsBranch = this.containComplex(this.optionsBranch, val)
      }
    }
    // searchSpkluKeyword (val) {
    //   const self = this
    //   if (!this.awaitingSearch) {
    //     setTimeout(() => {
    //       if (val !== '' && val !== null) {
    //         self.getOptionsSpklu()
    //       }
    //       self.awaitingSearch = false
    //     }, 1000)
    //   }
    //   this.awaitingSearch = true
    // }
  },
  methods: {
    async downloadExcel () {
      const param = {
        name: 'Detail Transaksi ' +  this.tanggalSekarang + '.xlsx',
        startDate: this.searchDate[0],
        endDate: this.searchDate[1],
        q: this.input.branch?.id,
      }

      await spkluService.getDetailTransacationExcell(param)
    },

    allowedDates: function (val) {
      var today = new Date()
      var year = today.getFullYear()
      var month = (today.getMonth() + 1).toString().padStart(2, '0')
      var day = today.getDate().toString().padStart(2, '0')
      var currentDate = `${year}-${month}-${day}`

      return val <= currentDate
    },

    async getSpkluData (param) {
      this.isFetching = true

      const response = await spkluService.getDetailTransacation(param)
      const data = response.data?.data?.content

      // let firstLoad = true
      this.locationMarkerList = []

      for (let i = 0; i < data?.length; i++) {
        // set location marker
        const position = latLng(data[i].latitude, data[i].longitude)

        // find existing index
        const idx = this.locationMarkerList.findIndex(
          (x) => x.id === data[i].spkluId
        )
        this.dateTimeString = data[i].tanggal

        const NewDate = new Date(this.dateTimeString).toLocaleDateString('id-ID', { year: 'numeric', month: '2-digit', day: '2-digit' })

        const newTime = new Date(this.dateTimeString)
        const hours = newTime.getHours().toString().padStart(2, '0')
        const minutes = newTime.getMinutes().toString().padStart(2, '0')

        const NewTimeFormat = `${hours}:${minutes}`

        if (idx === -1) {
          const newmarker = {
            id: data[i]?.idSpklu,
            chargeboxId: data[i].chargeboxId,
            connectorId: data[i].connectorId,
            dayaChargebox: data[i].dayaChargebox,
            durasi: data[i].durasi,
            idSpklu: data[i].idSpklu,
            kwh: data[i].kwh,
            namaChargebox: data[i].namaChargebox,
            namaConnector: data[i].namaConnector,
            namaSpklu: data[i].namaSpklu,
            payment: data[i].payment,
            pemda: data[i].pemda,
            periode: data[i].periode,
            provinsi: data[i].provinsi,
            rpadmin: data[i].rpadmin,
            rpkwh: data[i].rpkwh?.toFixed(0),
            rpmat: data[i].rpmat,
            rppakai: data[i].rppakai,
            rpppj: data[i].rpppj?.toFixed(0),
            // tanggal: data[i].tanggal,
            tanggal: NewDate + ('  ') + NewTimeFormat,
            trxid: data[i].trxid,
            ulp: data[i].ulp,
            unitupi: data[i].unitupi,
            up3: data[i].up3,
            namaupi: data[i].namaupi,
            namaap: data[i].namaap ?? '-',
            namaup: data[i].namaup ?? '-'

          }
          this.locationMarkerList.push(newmarker)
        } else if (idx > -1) {
          // firstLoad = false
          this.locationMarkerList[idx].jml_transaksi = data[i].transaksi
          this.locationMarkerList[idx].status = data[i].status
        }
      }

      // if (firstLoad) {
      //   if (this.zoom === 4) {
      //     this.zoom += 1
      //   } else {
      //     const self = this
      //     this.zoom -= 1
      //     setTimeout(function () {
      //       self.zoom += 1
      //     }, 300)
      //   }
      // }

      // set datatable client side data
      this.items = this.locationMarkerList.sort(function (a, b) {
        return b.jml_transaksi - a.jml_transaksi
      })

      const temp = this.items
      // reform data for excel export
      this.itemsExcel = await temp.map((item, index) => {
        return {
          Nomor: index + 1,
          CHARGEBOX_ID: item.chargeboxId,
          CONNECTOR_ID: item.connectorId,
          DAYA_CHARGEBOX: item.dayaChargebox,
          DURASI: item.durasi,
          ID_SPKLU: item.spkluId,
          KWH: item.kwh,
          NAMA_CHARGEBOX: item.namaChargebox,
          NAMA_CONNECTOR: item.namaConnector,
          NAMA_SPKLU: item.namaSpklu,
          PAYMENT: item.payment,
          'KOTA/KAB': item.pemda,
          PERIODE: item.periode,
          PROV: item.provinsi,
          RPADMIN: item.rpadmin,
          RPKWH: item.rpkwh,
          RPMAT: item.rpmat,
          RPPAKAI: item.rppakai,
          RPPPJ: item.rpppj,
          TGL_START: item.tanggal,
          TRXID: item.trxid,
          ULP: item.ulp,
          UNITUPI: item.unitupi,
          UP3: item.up3

        }
      })

      this.isFetching = false
    },
    async openDialog (marker) {
      await this.getSpkluAvailability(marker.id)
      this.dialogTitle = marker.nama
      this.dialog = true
    },
    async getSpkluAvailability (id) {
      const param = {
        idSpklu: id
      }
      const response = await spkluService.getDetailAvailabilitySpklu(param)
      const {
        data: { data }
      } = response
      this.chargeBoxList = data
    },
    iconSelector (data) {
      if (data.kategori !== 'PLN') {
        return '/maps/ic-spklu-blue.svg'
      } else if (data.jml_transaksi > 50) {
        return '/maps/ic-spklu-green.svg'
      } else if (data.jml_transaksi >= 11 && data.jml_transaksi <= 50) {
        return '/maps/ic-spklu-yellow.svg'
      } else if (data.jml_transaksi <= 10) {
        return '/maps/ic-spklu-red.svg'
      }
    },
    async getSpkluCard (param) {
      const response = await spkluService.getDetailTransaktionCard(param)
      const {
        data: {
          data: { kwh, rp, transaksi }
        }
      } = response
      this.cardItems = {
        hijau: kwh,
        kuning: rp,
        merah: transaksi
      }
    },

    async exportExcel () {
      document.getElementById('d').click()
    },
    openDialogFilter () {
      this.dialogFilter = true
    },

    async getBranchList () {
      const branch = JSON.parse(localStorage.getItem('branch_list'))?.data
      if (branch) {
        this.optionsBranch = branch
        this.tempOptionsBranch = branch
      } else {
        const param = {
          companyId: 1,
          branchId: ''
        }
        const response = await refService.getBranchList(param)
        const {
          data: { data }
        } = response

        const temp = data.map((item) => {
          // remap level 1
          item.child = item.child.map((item2) => {
            // remap level 2
            item2.child = item2.child.map((item3) => {
              // remap level 3
              item3.child = item3.child.map((item4) => {
                // remap level 4
                return {
                  id: item4.id,
                  name: item4.id.split('').join('.') + ' - ' + item4.name,
                  children: item4.child
                }
              })
              return {
                id: item3.id,
                name: item3.id.split('').join('.') + ' - ' + item3.name,
                children: item3.child
              }
            })
            return {
              id: item2.id,
              name: item2.id.split('').join('.') + ' - ' + item2.name,
              children: item2.child
            }
          })
          return {
            id: item.id,
            name: item.id.split('').join('.') + ' - ' + item.name,
            children: item.child
          }
        })

        this.optionsBranch = temp
        this.tempOptionsBranch = temp

        localStorage.setItem(
          'branch_list',
          JSON.stringify({
            data: temp
          })
        )
      }
    },
    treeClick (value) {
      if (value.length > 0) {
        const branch = JSON.parse(localStorage.getItem('branch_list'))?.data
        this.input.branch = this.findComplex(branch, value[0])
      }
    },
    async getOptionsSpklu (id) {
      this.paging.page = 0
      this.paging.size = 999

      // const param = Object.assign({ q: this.searchSpkluKeyword }, this.paging)
      const param = Object.assign({ q: id }, this.paging)
      const response = await refService.getSpkluList(param)
      const { data } = response
      if (data.success !== true) return

      if (this.input.branch.id !== param.q || param.q === undefined) {
        this.optionsSpklu = []
      } else {
        this.optionsSpklu = data.data.content.map((data) => {
          return {
            id: data.idSpklu,
            name: data.spkluName
          }
        })
      }
    },
    async reGetData () {
      let q = ''

      if (this.input.spklu && this.input.spklu.id) {
        q = this.input.spklu.id
      } else if (this.input.branch && this.input.branch.id) {
        q = this.input.branch.id
      }

      const isActive = this.input.is_active ? this.input.is_active.id : ''

      const param = Object.assign({
        card: this.input.jml_transaksi ? this.input.jml_transaksi.id : '',
        q: q,
        isActive: isActive
      })
      if (this.searchDate.length > 1) {
        param.startDate = this.searchDate[0]
        param.endDate = this.searchDate[1]
      } else if (this.searchDate.length === 1) {
        param.startDate = this.searchDate[0]
        param.endDate = this.searchDate[0]
      }

      this.getSpkluData(param)
      this.getSpkluCard(param)
    }
  }
}
</script>
<style scoped>
.summary-alert-title {
  font-weight: 400;
  font-size: 22px;
  color: #f9f9f9;
}

.summary-alert-value {
  font-weight: 600;
  font-size: 24px;
  color: #ffffff;
}

.summary-alert-title-black {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.summary-alert-value-black {
  font-weight: 600;
  font-size: 24px;
  color: #000000;
}

.search {
  height: 48px;
}

.leaflet-popup-close-button {
  color: none;
}

.leaflet-container {
  font-family: "Inter";
}

.popup-property {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #9a9a9a;
}

.popup-value {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #000000;
}

.popup-table tr td {
  padding: 5px;
}

.v-dialog__content--active {
  z-index: 224 !important;
}

.vue2leaflet-map {
  z-index: 200 !important;
}

.red-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/red-box.svg");
  /* background: linear-gradient(259deg, #FF5E5E 52.44%, #FF9898 100%); */
}

.yellow-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/yellow-box.svg");
  /* background: linear-gradient(255deg, #F3AF00 51.62%, #FFE39A 100%); */
}

.green-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/green-box.svg");
  /* background: linear-gradient(257deg, #5BBA2E 53.55%, #AAE190 100%); */
}

.white-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/white-box.svg");
  /* background: linear-gradient(261deg, #D9D9D9 50%, #F5F5F5 100%); */
}

.xcards {
  border-radius: 8px;
  background-size: cover;
  background-color: rgb(96, 204, 219);
  border-color: rgb(96, 204, 219)
}
</style>
